var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 46,
    viewBox: "0 0 67 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4451 31.2927L38.1572 26.5436H37.9616H34.53V31.2927H30.584V14.2461H37.9616C39.4715 14.2461 40.7836 14.4968 41.8958 15.0027C43.0079 15.5052 43.8629 16.2186 44.4627 17.1438C45.0636 18.0689 45.363 19.166 45.363 20.4316C45.363 21.6972 45.0593 22.7878 44.4497 23.7065C43.8434 24.623 42.9788 25.3244 41.858 25.8108L45.6819 31.2916H41.4451V31.2927ZM41.3716 20.4316C41.3716 19.4729 41.0625 18.7369 40.4464 18.2289C39.8303 17.7177 38.93 17.4604 37.7444 17.4604H34.53V23.4038H37.7444C38.93 23.4038 39.8303 23.1434 40.4464 22.6224C41.0625 22.1047 41.3716 21.3719 41.3716 20.4316Z",
    fill: "#040404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1474 27.6374H51.2337L49.7238 31.2927H45.6826L53.2775 14.2461H57.1749L64.7979 31.2927H60.6584L59.1474 27.6374ZM55.2013 18.1187L52.4993 24.6446H57.9066L55.2013 18.1187Z",
    fill: "#040404"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52399 17.4604H2.07129V14.2461H18.8109L16.9238 17.4604H11.47V31.2927H7.52399V17.4604Z",
    fill: "#040404"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4697 31.2927H20.354L15.8384 23.4708L11.4697 31.2927ZM24.9107 31.2927H30.585L20.9928 14.2461L18.0789 19.461L24.9107 31.2927Z",
    fill: "#040404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.5f3c802781c86691ed301de3a9a734ca.svg";
export { ForwardRef as ReactComponent };